import { Badge } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import styles from './CountBadge.styles';

const useStyles = makeStyles()(styles);

const CountBadge = props => {
    const { count = 0, variant = 'primary', className, ...remain } = props;
    const { classes, cx } = useStyles();

    if (!(count > 0)) {
        return null;
    }

    const isNeutral = variant === 'neutral';

    return (
        <Badge
            className={cx(isNeutral && classes.neutral, className)}
            badgeContent={count}
            {...(isNeutral ? {} : { color: 'primary' })}
            {...remain}
        />
    );
};

CountBadge.propTypes = {
    className: PropTypes.string,
    count: PropTypes.number,
    variant: PropTypes.oneOf(['primary', 'neutral']),
};

export default CountBadge;
